import { DataSourcesQueries } from '@frontend/api-data-sources';
import {
  useGetSchedulerV3FeatureFlagDetails,
  useGetWSMActiveLocationIds,
} from './use-get-scheduler-v3-feature-flag-details';

// Hook to check if Weave Schedule Management is enabled or not
export const useCheckHasWSM = (locationId?: string) => {
  const { isScheduleV3FlagEnabled, isLoading } = useGetSchedulerV3FeatureFlagDetails();

  const { isIntegratedOffice, isLoading: isLoadingIntegrationDetails } =
    DataSourcesQueries.useGetAccessibleIntegrations();
  const { wsmActiveLocationIds } = useGetWSMActiveLocationIds();

  let hasWSM = isScheduleV3FlagEnabled && wsmActiveLocationIds.length > 0;

  if (locationId) {
    const hasLocationWSM = wsmActiveLocationIds.includes(locationId);
    hasWSM = isScheduleV3FlagEnabled && !isIntegratedOffice && hasLocationWSM;
  }

  return {
    hasWSM,
    wsmActiveLocationIds,
    isLoading: isLoading || isLoadingIntegrationDetails,
  };
};
